import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./AuthSlice";
import globalReducer from "./GlobalSlice";
import menuReducer from "./MenuSlice";
import alertReducer from "./AlertSlice";
import taskCountSliceReducer from "./TaskCountSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    menu: menuReducer,
    alert: alertReducer,
    taskCount: taskCountSliceReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});
export default store;
